import React, { useState, useCallback, useContext } from 'react'
import styled from 'styled-components'

import Button from 'components/Button'
import { Input } from 'components/Input'
import { RFPDetailActionsContext } from '.'

const Wrapper = styled.div<{ isBackup: boolean }>`
  align-items: center;
  display: flex;

  > label {
    margin-right: 12px;
    text-transform: capitalize;
  }
  > ${Input} {
    margin-right: 20px;

    &:disabled {
      border-color: ${({ theme }) => theme.colors.backgroundSecondary};
      background-color: ${({ theme }) => theme.colors.backgroundSecondary};
    }
  }
  > ${Button} {
    margin-right: 4px;
    max-width: 90px;
  }
`
const LaneAwardForm = ({ proposal }: { proposal: LaneProposal }) => {
  const { partialUpdateLaneProposal } = useContext(RFPDetailActionsContext)
  const [volume, setVolume] = useState(
    proposal.awarded_type ? proposal.awarded_volume : proposal.capacity
  )
  const onBlurVolume = useCallback(
    ({ target: { value } }) => {
      const newValue = Number(value)
      if (isNaN(newValue) || proposal.awarded_volume === newValue) {
        return
      }
      partialUpdateLaneProposal(proposal.id, {
        awarded_volume: newValue,
      })
    },
    [partialUpdateLaneProposal, proposal.awarded_volume, proposal.id]
  )
  const onChangeVolume = useCallback(
    ({ target: { value } }) => {
      setVolume(Number(value))
    },
    [setVolume]
  )
  const onClickBackup = useCallback(() => {
    if (proposal.awarded_type === 'backup') {
      return
    }
    partialUpdateLaneProposal(proposal.id, {
      awarded_type: 'backup',
      awarded_volume: volume,
    })
  }, [partialUpdateLaneProposal, proposal.awarded_type, proposal.id, volume])
  const onClickPrimary = useCallback(() => {
    if (proposal.awarded_type === 'primary') {
      return
    }
    partialUpdateLaneProposal(proposal.id, {
      awarded_type: 'primary',
      awarded_volume: volume,
    })
  }, [partialUpdateLaneProposal, proposal.awarded_type, proposal.id, volume])
  const isBackup = proposal.awarded_type === 'backup'
  const isUpdating = proposal.meta?.isUpdating
  return (
    <Wrapper isBackup={isBackup}>
      <label htmlFor={`${proposal.id}_volume`}>Volume</label>
      <Input
        disabled={isUpdating || isBackup}
        id={`${proposal.id}_volume`}
        name="volume"
        onBlur={onBlurVolume}
        onChange={onChangeVolume}
        type="number"
        placeholder={isBackup ? '-' : ''}
        value={isBackup ? '' : volume}
      />
      <Button
        aria-label="Primary"
        disabled={isUpdating}
        onClick={onClickPrimary}
        variant={isBackup ? 'dark' : 'light'}
      >
        Primary
      </Button>
      <Button
        aria-label="Backup"
        disabled={isUpdating}
        onClick={onClickBackup}
        variant={isBackup ? 'light' : 'dark'}
      >
        Backup
      </Button>
    </Wrapper>
  )
}

export default LaneAwardForm
